export default "__VITE_ASSET__3e4d54b7__"